import { gsap } from 'gsap/all';
/* eslint-disable */
function calculateDistance(elem, mouseX, mouseY) {
    return Math.floor(Math.sqrt(Math.pow(mouseX - (elem.left + (elem.width / 2)), 2) + Math.pow(mouseY - (elem.top + (elem.height / 2)), 2)));
}

const circlesActive = 0;

function magnetize(el, rect, e) {
    const mX = e.pageX;
    const mY = e.pageY;

    const customDist = el.dataset.dist * 20 || 75;
    const centerX = rect.left + (rect.width / 2);
    const centerY = rect.top + (rect.height / 2);

    const deltaX = Math.floor((centerX - mX)) * -1;
    const deltaY = Math.floor((centerY - mY)) * -1;

    const distance = calculateDistance(rect, mX, mY);

    const yMod = el.classList.contains('--top') ? -8 : 8;
    const xMod = el.classList.contains('--right') ? 8 : -8;

    if (distance < customDist && !circlesActive) {
        gsap.to(el, 0.5, { y: deltaY + yMod, x: deltaX + xMod, scale: 1 });
        el.parentElement.classList.add('magnet');
    } else {
        gsap.to(el, 0.5, {
            y: 0, x: 0, scale: 1, ease: 'power4.easeOut',
        });
        el.parentElement.classList.remove('magnet');
    }
}

function magnetizeGrid(el, e) {
    const mX = e.pageX;
    const mY = e.pageY;
    const rect = el.getBoundingClientRect();

    const customDist = el.dataset.dist * 20 || 180;
    const centerX = rect.left + (rect.width / 2);
    const centerY = rect.top + (rect.height / 2);

    const deltaX = Math.floor((centerX - mX)) * -0.1;
    const deltaY = Math.floor((centerY - mY)) * -0.1;

    const distance = calculateDistance(rect, mX, mY);

    if (distance < customDist) {
        gsap.to(el, 0.8, { y: deltaY, x: deltaX, scale: 1 });
        // el.parentElement.classList.add('magnet');
    } else {
        gsap.to(el, 1, {
            y: 0, x: 0, scale: 1, ease: 'power4.easeOut',
        });
        // el.parentElement.classList.remove('magnet');
    }
}

const lerp = (a, b, n) => (1 - n) * a + n * b;
const { body } = document;
const getMousePos = (e) => {
    let posx = 0;
    let posy = 0;
    if (!e) e = window.event;
    if (e.pageX || e.pageY) {
        posx = e.pageX;
        posy = e.pageY;
    } else if (e.clientX || e.clientY) 	{
        posx = e.clientX + body.scrollLeft + document.documentElement.scrollLeft;
        posy = e.clientY + body.scrollTop + document.documentElement.scrollTop;
    }
    return { x: posx, y: posy };
};

class Cursor {
    constructor(el, instance) {
        this.hasTouch = false;
        if (document.documentElement.classList.contains('touchevents')) {
            this.hasTouch = true;
            return;
        }
        this.app = instance;
        this.DOM = { el };
        this.DOM.dot = this.DOM.el.querySelector('.cursor__inner--dot');
        this.DOM.circle = this.DOM.el.querySelector('.cursor__inner--circle');
        this.DOM.play = this.DOM.el.querySelector('.cursor__inner--play');
        this.bounds = {
            dot: this.DOM.dot.getBoundingClientRect(),
            circle: this.DOM.circle.getBoundingClientRect(),
            play: this.DOM.play.getBoundingClientRect(),
        };
        this.scale = 0;
        this.playScale = 0;
        this.opacity = 1;
        this.mousePos = { x: 0, y: 0 };
        this.lastMousePos = {
            dot: { x: 0, y: 0 },
            circle: { x: 0, y: 0 },
            play: { x: 0, y: 0 },
        };

        this.playEnterEvents = [];
        this.playLeaveEvents = [];
        this.lastScale = 0;
        this.lastPlayScale = 0;

        this.hoverEnterEvents = [];
        this.hoverLeaveEvents = [];
        this.dotScale = 1;
        this.lastDotScale = 1;

        this.initEvents();
        this.addEvents();
        this.addMenuIconEvents();

        if (!this.hasTouch) {
            gsap.ticker.add(this.render.bind(this));
        }
    }

    initEvents() {
        if (this.hasTouch) {
            return;
        }

        window.addEventListener('mousemove', (ev) => this.mousePos = getMousePos(ev));
    }

    addEvents() {
        if (this.hasTouch) {
            return;
        }

        const elements = document.querySelectorAll('*[data-cursor-enlarge]');

        elements.forEach((object, index) => {
            object.addEventListener('mouseenter', () => {
                this.dotScale = 2.5;
            });
            object.addEventListener('mouseleave', () => {
                this.dotScale = 1;
            });
        });
    }

    removeEvents() {
        const elements = document.querySelectorAll('*[data-cursor-enlarge]');

        this.hoverEnterEvents.forEach((event, index) => {
            const element = elements[index];
            element.removeEventListener('mouseenter', event);
        });

        this.hoverLeaveEvents.forEach((event, index) => {
            const element = elements[index];
            element.removeEventListener('mouseleave', event);
        });
    }

    addMenuIconEvents() {
        const toggles = [...document.querySelectorAll('.icon-grid__circle')];
        this.toggleEvents = [];

        toggles.forEach((element) => {
            function handle (ev) {
                window.requestAnimationFrame(() => {
                    const rect = element.getBoundingClientRect();
                    magnetize(element, rect, ev);
                });
            }

            window.addEventListener('mousemove', handle);
            this.toggleEvents.push(handle);
        });

        const circle = [...document.querySelectorAll('.icon-slider')];

        circle.forEach((element) => {
            function handle (ev) {
                window.requestAnimationFrame(() => {
                    const rect = element.getBoundingClientRect();
                    magnetize(element, rect, ev);
                });
            }

            window.addEventListener('mousemove', handle);
            // this.toggleEvents.push(handle);
        });
    }

    addPlayEvents() {
        if (this.hasTouch) {
            return;
        }

        const elements = document.querySelectorAll('*[data-cursor-play]');
        elements.forEach((object, index) => {
            const mouseEnter = () => {
                this.playScale = 1;
                this.DOM.dot.style.display = 'none';
            }

            const mouseLeave = () => {
                this.playScale = 0;
                this.DOM.dot.style.display = '';
            }

            object.addEventListener('mouseenter', mouseEnter);
            object.addEventListener('mouseleave', mouseLeave);

            this.playEnterEvents.push(mouseEnter);
            this.playLeaveEvents.push(mouseLeave);
        });
    }

    removePlayEvents() {
        const elements = document.querySelectorAll('*[data-cursor-play]');

        this.playEnterEvents.forEach((event, index) => {
            const element = elements[index];
            element.removeEventListener('mouseenter', event);
        });

        this.playLeaveEvents.forEach((event, index) => {
            const element = elements[index];
            element.removeEventListener('mouseleave', event);
        });
    }

    render() {
        this.lastMousePos.dot.x = lerp(this.lastMousePos.dot.x, this.mousePos.x - this.bounds.dot.width / 2, 1);
        this.lastMousePos.dot.y = lerp(this.lastMousePos.dot.y, this.mousePos.y - this.bounds.dot.height / 2, 1);
        this.lastMousePos.circle.x = lerp(this.lastMousePos.circle.x, this.mousePos.x - this.bounds.circle.width / 2, 0.15);
        this.lastMousePos.circle.y = lerp(this.lastMousePos.circle.y, this.mousePos.y - this.bounds.circle.height / 2, 0.15);
        this.lastMousePos.play.x = lerp(this.lastMousePos.play.x, this.mousePos.x - this.bounds.play.width / 2, 0.15);
        this.lastMousePos.play.y = lerp(this.lastMousePos.play.y, this.mousePos.y - this.bounds.play.height / 2, 0.15);
        this.lastScale = lerp(this.lastScale, this.scale, 0.15);
        this.lastDotScale = lerp(this.lastDotScale, this.dotScale, 0.15);
        this.lastPlayScale = lerp(this.lastPlayScale, this.playScale, 0.15);
        this.DOM.dot.style.transform = `translateX(${(this.lastMousePos.dot.x)}px) translateY(${this.lastMousePos.dot.y}px) scale(${this.lastDotScale})`;
        this.DOM.circle.style.transform = `translateX(${(this.lastMousePos.circle.x)}px) translateY(${this.lastMousePos.circle.y}px) scale(${this.lastScale})`;
        this.DOM.play.style.transform = `translateX(${(this.lastMousePos.play.x)}px) translateY(${this.lastMousePos.play.y}px) scale(${this.lastPlayScale})`;
    }

    enter() {
        if (this.hasTouch) {
            return;
        }

        this.scale = 1;
        this.DOM.dot.style.display = 'none';
    }

    leave() {
        if (this.hasTouch) {
            return;
        }
        this.scale = 0;
        this.DOM.dot.style.display = '';
    }

    addGridEvents(toggleClassName) {
        const toggles = [...document.querySelectorAll(toggleClassName)];
        this.listeners = [];
        toggles.forEach((element) => {
            function listener(ev) {
                window.requestAnimationFrame(() => {
                    magnetizeGrid(element, ev);
                });
            }

            window.addEventListener('mousemove', listener);
            this.listeners.push(listener);
        });
    }

    removeGridEvents(toggleClassName) {
        const toggles = [...document.querySelectorAll(toggleClassName)];
        toggles.forEach((element, index) => {
            const listener = this.listeners[index]

            if (listener) {
                window.removeEventListener('mousemove', listener);
            }
        });
    }
}

export { Cursor };
